// extracted by mini-css-extract-plugin
export default {"scim":"SCIMTokens_scim__wGEeI","visibilityButton":"SCIMTokens_visibilityButton__-RPI2"};